import React from 'react';
import { ReactComponent as SettingsIcon } from '../assets/settings.svg';

export default function Settings() {
  return (
    <div className='header__settings'>
      <SettingsIcon />
    </div>
  );
}
